import { createStore }  from 'vuex'
import adminStore       from './modules/admin'
import sectionStore     from './modules/section'
import electionsStore        from './modules/elections'
import {clientPlugin}   from './plugins/client'

const SectionStore = createStore({
  modules: {
    admin: adminStore,
    section: sectionStore,
    elections: electionsStore
  },
  strict: false,
  plugins: [
    clientPlugin
  ],
  preserveState: true
})

export default SectionStore